<template>
  <v-menu
    :value="showMenu"
    @change="toggleMenu"
    :position-x="x"
    :position-y="y"
    absolute
    offset-y
    content-class="splicing-menu"
  >
    <v-list dense id="splicing-menu-list" v-if="showConnectionOrChange">
      <v-list-item @click="$emit('add-connection')">
        <v-list-item-title
          >{{ $t("Add") }} {{ $tc("Connection", 1) }}</v-list-item-title
        >
      </v-list-item>

      <v-list-item @click="$emit('change-connection')">
        <v-list-item-title>
          {{ $t("Change") }} {{ $tc("Connection", 1) }}
        </v-list-item-title>
      </v-list-item>
    </v-list>

    <v-list dense id="splicing-menu-list" v-else-if="state === 'list'">
      <v-list-item
        @click="$emit('collapse-list-splitter')"
      >
        <v-list-item-avatar>
          <v-icon left>mdi-arrow-collapse-vertical</v-icon>
        </v-list-item-avatar>

        <v-list-item-title>{{ isExpand ? $t("Expand") : $t("Collapse")}}</v-list-item-title>
      </v-list-item>

      <v-list-item  @click="$emit('hide-list-splitter')">
        <v-list-item-avatar> <v-icon left>mdi-eye-off</v-icon> </v-list-item-avatar>
        <v-list-item-title>
          {{ $t("HideEquipment")}}
        </v-list-item-title>
      </v-list-item>
      <v-list-item  @click="$emit('delete-splitter')">
        <v-list-item-avatar> <v-icon left>delete</v-icon> </v-list-item-avatar>
        <v-list-item-title>
          {{ $t("DeleteEquipment")}}
        </v-list-item-title>
      </v-list-item>
    </v-list>

    <v-list dense id="splicing-menu-list" v-else>
      <v-list-item
        v-if="state && (state === 'occupied' || state === 'split' || state === 'splitter') && !disabled"
        @click="$emit('inspect')"
      >
        <v-list-item-avatar>
          <v-icon left>manage_search</v-icon>
        </v-list-item-avatar>

        <v-list-item-title>{{ `${$t("View")} ${$tc("Connection", 1)}` }}</v-list-item-title>
      </v-list-item>

      <v-list-item v-if="actionType === 'edit' && state !== 'free'" @click="$emit('remove-connections')">
        <v-list-item-avatar> <v-icon left>delete</v-icon> </v-list-item-avatar>

        <v-list-item-title>
          {{ $t("Remove") }} {{ $tc("Connection", 2) }}
        </v-list-item-title>
      </v-list-item>

      <v-list-item v-if="state === 'splitter'" @click="$emit('view-splitter')">
        <v-list-item-avatar> <v-icon left>mdi-eye</v-icon> </v-list-item-avatar>
        <v-list-item-title>
          {{ $t("ShowEquipment")}}
        </v-list-item-title>
      </v-list-item>

      
      <v-list-item v-if="state === 'splitter' && actionType === 'edit'" @click="$emit('edit-splitter')">
        <v-list-item-avatar> <v-icon left>edit</v-icon> </v-list-item-avatar>
        <v-list-item-title>
          {{ $t("EditEquipment")}}
        </v-list-item-title>
      </v-list-item>
      
      <v-list-item v-if="(actionType === 'edit' && side !== 'destination' && (state === 'free' || state === 'splitter'))" @click="$emit('connect-to')">
        <v-list-item-avatar> <v-icon left>mdi-transit-connection-variant</v-icon> </v-list-item-avatar>
        <v-list-item-title>
          Connect to
        </v-list-item-title>
      </v-list-item>

      <v-list-item v-if="actionType === 'edit' && side === 'destination' && isTechLocal && state === 'free'" @click="$emit('connect-to')">
        <v-list-item-avatar> <v-icon left>mdi-transit-connection-variant</v-icon> </v-list-item-avatar>
        <v-list-item-title>
          Connect to
        </v-list-item-title>
      </v-list-item>
      <v-list-item v-if="isFiber && state !== 'splitter'" @click="$emit('show-circuit')">
        <v-list-item-avatar>
          <v-icon left>settings_input_composite</v-icon>
        </v-list-item-avatar>
        <v-list-item-title>
          {{ $t("ShowFiberCircuit") }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: "ConnectionObjectMenu",

  props: {
    showMenu: Boolean,
    x: Number,
    y: Number,

    state: String,

    side: String,

    isFiber: Boolean,

    disabled: Boolean,

    showConnectionOrChange: Boolean,

    isExpand: Boolean,
    
    isTechLocal: {
      type: Boolean,
      default: false
    },
    actionType: {
      type: String
    }
  },

  methods: {
    toggleMenu(value) {
      if (!value) {
        this.$emit("close-menu");
      }
    }
  }
};
</script>

<style scoped>
.splicing-menu {
  overflow: visible;
}
</style>
<style>
.v-list--dense .v-list-item,
.v-list-item--dense {
  min-height: 35px !important;
  height: 35px !important;
  align-items: start;
}
</style>

<style>
#splicing-menu-list .v-list-item {
  min-height: 30px !important;
  height: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Splicing/ObjectTable/ConnectionObjectMenu.vue